<template>
  <div class="input-default">
    <the-mask
      :placeholder="$t('components.InputDefault.placeholderCpf')"
      v-if="name == 'cpf'"
      :mask="['###.###.###-##']"
      :style="{
        'background': game !== 'repense' ? '#fff' : '#001420',
        'color': game !== 'repense' ? '#001420' : '#fff',
        'border': game !== 'repense' ? '2px solid #cccc;' : '0.5px solid #001420'
      }"        
    />
    <the-mask
      :placeholder="placeholder"
      v-if="name == 'graduationEndDate'"
      :id="name"
      :mask="['##/####']"    
      :style="{
        'background': game !== 'repense' ? '#fff' : '#001420',
        'color': game !== 'repense' ? '#001420' : '#fff',
        'border': game !== 'repense' ? '2px solid #cccc;' : '0.5px solid #001420'
      }"        
    />
    <Sugestions :id="name" :name="name" :placeholder="placeholder" :values="values" class="input-padrao" v-if="name == 'graduationCourse'"></Sugestions>
    <Select :id="name" :name="name"  :placeholder="placeholder" :values="values" v-if="name == 'preferredOffice'"></Select>
    <input
      v-if="name == 'nome' || name == 'email' || name == 'password' || name == 'confirmEmail' || name == 'confirmPass'"
      :type="type"
      :name="name"
      :id="name"
      class="input-padrao"
      required
      autocomplete="off"
      :placeholder="placeholder"
      :style="{
        'background': game !== 'repense' ? '#fff' : '#001420',
        'color': game !== 'repense' ? '#001420' : '#fff',
        'border': game !== 'repense' ? '2px solid #cccc;' : '0.5px solid #001420'
      }"
    />
  </div>
</template>
<script>
import { TheMask } from "vue-the-mask";
import Sugestions from "./Sugestions"
import Select from "./SelectField"
  

export default {
  components: {
    TheMask, Sugestions, Select
  },
  data(){
    return{
      game: '',
      colors: {}
    }
  },
  created(){
		this.colors = JSON.parse(localStorage.getItem("colors"));
		this.game = localStorage.getItem("game-redirect");
  },
  props: {
    type: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    values: {
      type: Array,
      required: false
    },
    fieldPropName: {
      type: String,
      required: false
    }
  }
};
</script>
<style lang="scss">
.input-default {
  input {
    width: calc(100% - 20px);
    margin-top: 5%;
    border: none;
    border-bottom: 1px solid #858585;
    font-size: 19px;
    // color: #30353a;
    font-weight: bold;
    outline: none;
    border-radius: 11px;
    padding: 15px 10px;
    &::placeholder {
      font-weight: 300;
    }
  }
}
</style>
